// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"438":"02f80bb1","504":"83dd126d","584":"ee72d073","746":"fed8477b"}[chunkId] + ".chunk.css";
};